import { IEvaluationCommand } from "@Evaluation/cqrs";

export class CreateSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.CreateSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	Name: string;
	Description: string;
	ResponseDueDateIsoString: string | null;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, name: string, description: string, responseDueDateIsoString: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
		this.Name = name;
		this.Description = description;
		this.ResponseDueDateIsoString = responseDueDateIsoString;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.CreateSurveyCommandV1, TCh.Domain.Evaluation'
	}
}
export class UpdateSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.UpdateSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	Name: string;
	Description: string;
	ResponseDueDateIsoString: string | null;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, name: string, description: string, responseDueDateIsoString: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
		this.Name = name;
		this.Description = description;
		this.ResponseDueDateIsoString = responseDueDateIsoString;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.UpdateSurveyCommandV1, TCh.Domain.Evaluation'
	}
}
export class DeleteSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.DeleteSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.DeleteSurveyCommandV1, TCh.Domain.Evaluation'
	}
}

export class IncludeSubSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.IncludeSubSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	SubSurveyId: number;
	VoteStrength: number;

	constructor(workspaceId: number, projectId: number, evalModelId: number, masterSurveyId: number, subSurveyId: number, voteStrength: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = masterSurveyId.toString();
		this.SubSurveyId = subSurveyId;
		this.VoteStrength = voteStrength;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.IncludeSubSurveyCommandV1, TCh.Domain.Evaluation'
	}
}
export class ChangeSubSurveyVoteStrengthCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.ChangeSubSurveyVoteStrengthCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	SubSurveyId: number;
	VoteStrength: number;

	constructor(workspaceId: number, projectId: number, evalModelId: number, masterSurveyId: number, subSurveyId: number, voteStrength: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = masterSurveyId.toString();
		this.SubSurveyId = subSurveyId;
		this.VoteStrength = voteStrength;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.ChangeSubSurveyVoteStrengthCommandV1, TCh.Domain.Evaluation'
	}
}
export class ExcludeSubSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.ExcludeSubSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	SubSurveyId: number;

	constructor(workspaceId: number, projectId: number, evalModelId: number, masterSurveyId: number, subSurveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = masterSurveyId.toString();
		this.SubSurveyId = subSurveyId;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.ExcludeSubSurveyCommandV1, TCh.Domain.Evaluation'
	}
}

export class ExcludeCriteriaPanelistCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.ExcludeCriteriaPanelistCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;

	constructor(workspaceId: number, surveyId: number, projectUserId: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.ExcludeCriteriaPanelistCommandV1, TCh.Domain.Evaluation'
	}
}
export class IncludeCriteriaPanelistCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.IncludeCriteriaPanelistCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;

	constructor(workspaceId: number, surveyId: number, projectUserId: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.IncludeCriteriaPanelistCommandV1, TCh.Domain.Evaluation'
	}
}
export class ChangeCriteriaPanelistVoteStrengthCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.ChangeCriteriaPanelistVoteStrengthCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;
	OldVoteStrength: number;
	NewVoteStrength: number;

	constructor(workspaceId: number, surveyId: number, projectUserId: number, oldVoteStrength: number, newVoteStrength: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
		this.OldVoteStrength = oldVoteStrength;
		this.NewVoteStrength = newVoteStrength;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.ChangeCriteriaPanelistVoteStrengthCommandV1, TCh.Domain.Evaluation'
	}
}



export class StartSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.StartSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.StartSurveyCommandV1, TCh.Domain.Evaluation'
	}
}

export class StopSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.StopSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.StopSurveyCommandV1, TCh.Domain.Evaluation'
	}
}


export class SendEmailCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.SendEmailCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUsersIds: number[];
	EmailSubject: string;
	EmailBody: string;

	constructor(workspaceId: number, surveyId: number, projectUsersIds: number[], emailSubject: string, emailBody: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUsersIds = projectUsersIds;
		this.EmailSubject = emailSubject;
		this.EmailBody = emailBody;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.SendEmailCommandV1, TCh.Domain.Evaluation'
	}
}


export class ExportPanelistVotesToXlsCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.ExportPanelistVotesToXlsCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	ProjectUserId: number;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, projectUserId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.ExportPanelistVotesToXlsCommandV1, TCh.Domain.Evaluation'
	}
}

export class SavePanelistCriterionVotesCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.SavePanelistCriterionVotesCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	EvalModelId: number;
	Id: string;
	ProjectUserId: number;
	CriterionId: number;
	Votes: any[];

	constructor(workspaceId: number, evalModelId: number, surveyId: number, projectUserId: number, criterionId: number, votes: any[])
	{
		this.WorkspaceId = workspaceId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
		this.CriterionId = criterionId;
		this.Votes = votes;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.SavePanelistCriterionVotesCommandV1, TCh.Domain.Evaluation'
	}
}

export class SavePanelistVoteCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.SavePanelistVoteCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;
	QuestionId: string;
	VoteValue: number | null;
	VoteComment: string | null;

	constructor(workspaceId: number, surveyId: number, projectUserId: number, questionId: string, voteValue: number | null, voteComment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
		this.QuestionId = questionId;
		this.VoteValue = voteValue;
		this.VoteComment = voteComment;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.SavePanelistVoteCommandV1, TCh.Domain.Evaluation'
	}
}

export class SavePanelistVoteCommentCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.SavePanelistVoteCommentCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;
	QuestionId: string;
	Comment: string | null;

	constructor(workspaceId: number, surveyId: number, projectUserId: number, questionId: string, comment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
		this.QuestionId = questionId;
		this.Comment = comment;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.SavePanelistVoteCommentCommandV1, TCh.Domain.Evaluation'
	}
}


export class SavePanelVoteCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.SavePanelVoteCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	QuestionId: string;
	VoteValue: number | null;
	VoteComment: string | null;

	constructor(workspaceId: number, surveyId: number, questionId: string, voteValue: number | null, voteComment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.QuestionId = questionId;
		this.VoteValue = voteValue;
		this.VoteComment = voteComment;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.SavePanelVoteCommandV1, TCh.Domain.Evaluation'
	}
}

export class SavePanelVoteCommentCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.SavePanelVoteCommentCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	QuestionId: string;
	Comment: string | null;

	constructor(workspaceId: number, surveyId: number, questionId: string, comment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.QuestionId = questionId;
		this.Comment = comment;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.CriteriaSurveys.Commands.SavePanelVoteCommentCommandV1, TCh.Domain.Evaluation'
	}
}






